export default __webpack_public_path__ + "static/media/siemens-ag-logo.2675d515.svg";